import { render } from "./SggAvgAmount.vue?vue&type=template&id=75280090&ts=true"
import script from "./SggAvgAmount.vue?vue&type=script&lang=ts"
export * from "./SggAvgAmount.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__